<template>
  <div class="top_container">
    <div class="logo_wrapper">
      <img src="/img/logo.png" alt="logo" />
      <div class="logo">
        <div class="zh">上海甲申速递有限公司</div>
        <div class="en">SHANGHAI FIRST EXPRESS COMPANY LIMITED</div>
      </div>
    </div>
    <div class="contact_wrapper">
      <span class="tel_text">
        <i class="iconfont">&#xe628;</i>
        全国服务咨询热线
      </span>
      <span class="tel_tel">
        021-65957777
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'jsTop'
}
</script>

<style lang="scss" scoped>
.top_container {
  max-width: 1200px;
  height: 85px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  padding: 5px 0;
  .logo_wrapper {
    display: flex;
    .logo {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 10px;
      color: #28176e;
      .zh {
        font-family: '华文行楷';
        font-size: 32px;
      }
      .en {
        font-family: '黑体';
        font-size: 14px;
      }
    }
  }
  .contact_wrapper {
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    font-family: SourceHanSansCN-Regular;
    line-height: 40px;
    .tel_text {
      font-size: 14px;
      color: #000000;
    }
    .tel_tel {
      font-size: 28px;
      color: #0054a6;
    }
  }
}
</style>
